import { BomItemsDto } from "./bom-details.model";

export class SoData {
    saleOrder:number;
    minGrade:number;
    maxGrade:number;
    bomItemsData:BomItemsDto[];
}